module.exports = "/images/icon-balloons.svg?55c273c1a2c6674639ef9241bff922ff";